import { TItemDescriptions } from 'factions/factionTypes'
import { tagAs } from 'factions/metatagger'
import {
  CHARGE_PHASE,
  COMBAT_PHASE,
  DURING_GAME,
  DURING_SETUP,
  HERO_PHASE,
  MOVEMENT_PHASE,
  SAVES_PHASE,
  START_OF_HERO_PHASE,
  START_OF_ROUND,
  START_OF_SHOOTING_PHASE,
  TURN_ONE_START_OF_ROUND,
} from 'types/phases'

const CommandTraits = {
  //Vanari
  'Masterful Tactician': {
    effects: [
      {
        name: `Masterful Tactician - Reaction: You declared the 'Redeploy' command for a visible friendly Lumineth Realm-Lords unit wholly within 12" of this unit`,
        desc: `Effect: If you roll a 1-3 when determining the distance that unit can move, you can use a value of 4 instead.`,
        when: [MOVEMENT_PHASE],
      },
    ],
  },
  'Acolyte of the Runes': {
    effects: [
      {
        name: `Acolyte of the Runes`,
        desc: `Declare: Pick a friendly Lumineth Realm-Lords Hero wholly within 12" of this unit to be the target.
        Effect: That Hero can be picked as an additional target the next time you use the 'Depict Rune' ability.`,
        when: [START_OF_ROUND],
      },
    ],
  },
  'Flawless Commander': {
    effects: [
      {
        name: `Flawless Commander`,
        desc: `Declare: Pick up to 3 visible friendly Lumineth Realm-Lords Infantry units wholly within 18" of this unit to be the targets.
        Effect: Each target can use the 'Normal Move' ability as if it were your movement phase.`,
        when: [DURING_SETUP],
      },
    ],
  },
  'Flawless Commander (SoG)': {
    effects: [
      {
        name: `Flawless Commander - Passive`,
        desc: `Effect: Add 2" to the Move characteristic of friendly Lumineth Realm-lords Infantry units while they are wholly within 12" of this unit.`,
        when: [MOVEMENT_PHASE],
      },
    ],
  },
  'Aetherquartz Requisitioner': {
    effects: [
      {
        name: `Aetherquartz Requisitioner - Once Per Battle - Reaction: You declared a Spell ability for a Lumineth Realm-Lords Wizard within this unit's combat range`,
        desc: `Effect: Add 3 to the casting roll for that spell.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Martial Perfectionist': {
    effects: [
      {
        name: `Martial Perfectionist`,
        desc: `Declare: Pick a visible enemy unit within 12" of this unit that is damaged or that had any models slain this turn to be the target. 
        Effect: Roll a dice. On a 3+, add 1 to wound rolls for combat attacks made by friendly Lumineth Realm-lords Infantry units that target that enemy unit for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Aelementiri Conclave (AoR)': {
    effects: [
      {
        name: `World-Mage - Passive`,
        desc: `Effect: Add 1 to casting rolls for this unit for each unique rune depicted on your battle scripture.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Vanari Paragons (AoR)': {
    effects: [
      {
        name: `Master Duellist`,
        desc: `Declare: Pick a visible enemy Hero in combat with this unit to be the target.
        Effect: Roll a dice. On a 4+:
        If the target has an artefact of power, it no longer has that artefact of power.
        The target has Strike-Last for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  //Scinari
  /* Spellmaster: {
    effects: [
      {
        name: `Spellmaster`,
        desc: `Once per battle, this general can use the Magical Boost aetherquartz reserve ability without using an aetherquartz reserve to do so.`,
        when: [HERO_PHASE],
      },
    ],
  },
  Loremaster: {
    effects: [
      {
        name: `Loremaster`,
        desc: `The general knows 1 extra spell from the Lore of Hysh.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Fast Learner': {
    effects: [
      {
        name: `Fast Learner`,
        desc: `This general can attempt to unbind 1 extra spell in the enemy hero phase. In addition, the second time that this general attempts to unbind a spell in the same enemy hero phase, you can reroll the unbinding roll.`,
        when: [HERO_PHASE],
      },
    ],
  },
  //Windmage
  'Grand Windrider': {
    effects: [
      {
        name: `Grand Windrider`,
        desc: `Replace this general's Windleap ability with: "If a friendly Windchargers unit starts a move wholly within 24" of this general, when it makes that move, that unit has a Move characteristic of 16" and can fly.`,
        when: [MOVEMENT_PHASE],
      },
    ],
  },
  Swift: {
    effects: [
      {
        name: `Swift`,
        desc: `Add 3" to this general's Move characteristic.`,
        when: [MOVEMENT_PHASE],
      },
    ],
  },
  'Gravity-defying Champion': {
    effects: [
      {
        name: `Gravity-defying Champion`,
        desc: `Once per battle, you can reroll 1 run roll, 1 charge roll, and 1 casting roll for this general.`,
        when: [HERO_PHASE, CHARGE_PHASE, MOVEMENT_PHASE],
      },
    ],
  },
  //Stonemage
  'Tectonically Attuned': {
    effects: [
      {
        name: `Tectonically Attuned`,
        desc: `At the start of your shooting phase, you can pick 1 friendly Spirit of the Mountain within 3" of this general. Add 1 to the Attacks characteristic of that unit's Geomantic Blast until the end of that phase.`,
        when: [START_OF_SHOOTING_PHASE],
      },
    ],
  },
  Enduring: {
    effects: [
      {
        name: `Enduring`,
        desc: `Add 3 to the general's wound characteristic.`,
        when: [DURING_GAME],
      },
    ],
  },
  'Unyielding Toughness': {
    effects: [
      {
        name: `Unyielding Toughness`,
        desc: `At the start of your hero phase, you can pick 1 friendly Stoneguard unit wholly within 6" of this general. Add 1 to the Wounds characteristic of that unit until your next hero phase. Designer's Note: This can result in a model that is affected by this ability being slain if the wounds allocated to that model equal or exceed its Wounds characteristic once the effect of this ability ends.`,
        when: [START_OF_HERO_PHASE, DURING_GAME],
      },
    ],
  }, */
} satisfies TItemDescriptions

// Always export using tagAs
export default tagAs(CommandTraits, 'command_trait')
